/* eslint react-hooks/exhaustive-deps: 0 */
import React, { lazy, Suspense, useEffect, useState } from 'react';
import { bool, number, object, shape, string } from 'prop-types';
import classnames from 'classnames';
import { getContext, I18n } from '@fiverr-private/fiverr_context';
import { StatusToast } from '@fiverr-private/orca';
import { JS_JOIN_HOOK } from '../../../utils/constants';
import { CUSTOM_ORDER_SOURCE } from '../../../common/customOrder/constants';
import { ACTIVE } from '../../../utils/constants/userStatuses';
import { isLoggedInUser } from '../../../utils/isLoggedInUser';
import { getCustomPackageRedirectUrl } from '../../../utils/customOrder';
import { ACTIVATE_ACCOUNT_ERROR_DURATION, ACTIVATE_ACCOUNT_ERROR_TOAST_KEY } from './config';
import { buildCustomOrderProps } from './api';

import './style.scss';

const CustomOrder = lazy(() =>
    import(/* webpackChunkName: 'CustomOrder' */'@fiverr-private/custom_order/src/entries/CustomOrderEntry')
);

const getGuestAttributes = () => ({
    'data-redirect-url': getCustomPackageRedirectUrl()
});

const CustomOrderTab = (
    { responseTime, customOrder },
    { pathfinderWrapper, logger, currencyConverter, biEvents }
) => {
    const { locale, pathParameters } = getContext();

    const [data, setData] = useState(null);
    const [customAttributes, setCustomAttributes] = useState({});

    const { currentUserStatus } = customOrder;
    const biEnrichmentData = biEvents.getEnrichmentData();
    const isLoggedIn = isLoggedInUser();
    const isGuest = !isLoggedIn;
    const allowSubmission = currentUserStatus === ACTIVE;

    useEffect(() => {
        if (!data) {
            fetchData();
        }

        if (isGuest) {
            setCustomAttributes(getGuestAttributes());
        }
    }, [data]);

    const fetchData = async() => {
        const { slug: gigSlug, username: sellerUsername } = pathParameters;

        const data = await buildCustomOrderProps({ sellerUsername, gigSlug, pathfinderWrapper, logger });
        setData(data);
    };

    const onClick = () => {
        if (allowSubmission || isGuest) {return;}

        StatusToast.raise({
            message: <I18n k={ACTIVATE_ACCOUNT_ERROR_TOAST_KEY} locale={locale}/>,
            duration: ACTIVATE_ACCOUNT_ERROR_DURATION,
            theme: StatusToast.THEMES.ERROR
        });
    };

    const currency = currencyConverter.getCurrency();
    const classNames = classnames('custom-order-tab', {
        'is-loading': !data,
        [JS_JOIN_HOOK]: isGuest
    });

    return (
        <div className={classNames} {...customAttributes} onClick={onClick}>
            {data &&
            <Suspense fallback={<div/>}>
                <CustomOrder {...data}
                    currency={currency}
                    responseTime={responseTime}
                    ctaText={<I18n k={'gig_page_perseus.custom_order.send'}/>}
                    isLoggedIn={isLoggedIn}
                    allowSubmission={allowSubmission}
                    source={CUSTOM_ORDER_SOURCE}
                    biEnrichmentData={biEnrichmentData}
                    isFourthPackageTest/>
            </Suspense>
            }
        </div>
    );
};

CustomOrderTab.propTypes = {
    responseTime: number,
    customOrder: shape({
        currentUserStatus: string,
        allowCustomOrders: bool
    })
};

CustomOrderTab.contextTypes = {
    currencyConverter: object,
    pathfinderWrapper: object,
    logger: object,
    biEvents: object
};

export default CustomOrderTab;
